(function () {
  function setFraction(sw, root) {
    var cur = root.querySelector('.pdp-linked-products__frac-current');
    var tot = root.querySelector('.pdp-linked-products__frac-total');
    if (cur) cur.textContent = String(sw.activeIndex + 1);
    if (tot) tot.textContent = String(sw.slides.length);
  }

  function initCarousel(root) {
    if (!root || !root.classList.contains('pdp-linked-products--carousel')) return;
    var swiperEl = root.querySelector('.pdp-linked-products__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
    var prev = root.querySelector('.pdp-linked-products__prev');
    var next = root.querySelector('.pdp-linked-products__next');
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 14,
      watchOverflow: true,
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      on: {
        init: function (sw) {
          setFraction(sw, root);
        },
        slideChange: function (sw) {
          setFraction(sw, root);
        }
      }
    });
  }

  function scan(scope) {
    var root = scope || document;
    root.querySelectorAll('.pdp-linked-products--carousel').forEach(initCarousel);
  }

  window.reinitializePdpLinkedProducts = function (container) {
    scan(container || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });
})();
